import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Navbar from "../../components/navbar";
import "./statsView.css";
import { getVisioActivitySummary } from "../../services/apiService";
import { withTranslation } from "react-i18next";
import Loading from "carbon-components-react/lib/components/Loading";
import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";
import { trackPageView } from "../../services/analyticsService";
import { toastTheError } from "../../services/toastService";

class statsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teacher: JSON.parse(localStorage.getItem("teacher")),
      inProgress: false,
      stats: [],
      selectedStat: null
    };

    this.getData = this.getData.bind(this);
    this.monthChanged = this.monthChanged.bind(this);
  }
  componentDidMount() {
    this.getData();
    trackPageView();
  }
  getData() {
    this.setState({ inProgress: true });
    getVisioActivitySummary()
      .then((data) => {
        this.setState({
          stats: data.results,
          selectedStat: data.results[0],
          inProgress: false
        });
      })
      .catch((error) => {
        toastTheError(error);
      });
  }
  monthChanged(event) {
    this.setState({
      selectedStat: JSON.parse(event.target.value)
    });
  }
  render() {
    const { t } = this.props;
    if (!this.state.teacher) {
      return <Redirect to="/" />;
    }
    return (
      <div className="view">
        <Navbar />
        {this.state.inProgress ? (
          <Loading withOverlay={true} />
        ) : (
          <div className="stats-view">
            <div className="stats-wrapper">
              <h2
                className="stats-title"
                style={{
                  paddingBottom: "7px",
                  borderBottom: "2px solid #dadedf"
                }}
              >
                {t("stats")}
              </h2>
              <div className="header-wrapper">
                <span style={{ marginRight: "16px" }}>{t("period")}</span>
                <Select
                  defaultValue={this.state.selectedStat}
                  id="monthselector"
                  onChange={this.monthChanged}
                  hideLabel={true}
                >
                  {this.state.stats.map((stat, index) => {
                    return (
                      <SelectItem
                        key={index}
                        value={JSON.stringify(stat)}
                        text={`${stat.summary_month} / ${stat.summary_year}`}
                      />
                    );
                  })}
                </Select>
              </div>
              <div style={{ marginTop: "16px" }}>
                <section className="bx--structured-list">
                  <div className="bx--structured-list-tbody">
                    {this.state.selectedStat ? (
                      <>
                        {this.state.teacher.can_review_question && (
                          <>
                            <h3 className="stats-subtitle">
                              {t("questionReview")}
                            </h3>
                            <div className="bx--structured-list-row">
                              <div className="bx--structured-list-td bx--structured-list-content--nowrap">
                                {t("numOfReviewed")}
                              </div>
                              <div className="bx--structured-list-td">
                                {
                                  this.state.selectedStat.data.question_review
                                    .count
                                }
                              </div>
                            </div>
                            <div className="bx--structured-list-row">
                              <div className="bx--structured-list-td bx--structured-list-content--nowrap">
                                {t("totalEarning")}
                              </div>
                              <div className="bx--structured-list-td">
                                {
                                  this.state.selectedStat.data.question_review
                                    .earning
                                }
                              </div>
                            </div>
                          </>
                        )}
                        {this.state.teacher.can_review_answer && (
                          <>
                            <h3 className="stats-subtitle">
                              {t("answerReview")}
                            </h3>
                            <div className="bx--structured-list-row">
                              <div className="bx--structured-list-td bx--structured-list-content--nowrap">
                                {t("numOfReviewed")}
                              </div>
                              <div className="bx--structured-list-td">
                                {
                                  this.state.selectedStat.data.answer_review
                                    .count
                                }
                              </div>
                            </div>
                            <div className="bx--structured-list-row">
                              <div className="bx--structured-list-td bx--structured-list-content--nowrap">
                                {t("totalEarning")}
                              </div>
                              <div className="bx--structured-list-td">
                                {
                                  this.state.selectedStat.data.answer_review
                                    .earning
                                }
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ) : null}
                  </div>
                </section>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default withTranslation("kunduz")(statsView);
